import React, { useRef, useEffect, useState } from "react";
import Typewriter from "typewriter-effect";
import videobg from "../videos/home-optimized.mp4";
import posterImg from "../videos/home-poster.jpg";
import homeContent from "../content/home";

const Home = ({ classicHeader, darkTheme, handleNavClick }) => {
  const videoRef = useRef(null);
  const [videoError, setVideoError] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleCanPlay = () => {
      video.play().catch(() => setVideoError(true));
    };
    const handleError = () => setVideoError(true);
    const handleStalled = () => {
      setTimeout(() => {
        if (video.paused) video.play().catch(() => {});
      }, 1000);
    };

    video.addEventListener("canplaythrough", handleCanPlay);
    video.addEventListener("error", handleError);
    video.addEventListener("stalled", handleStalled);

    return () => {
      video.removeEventListener("canplaythrough", handleCanPlay);
      video.removeEventListener("error", handleError);
      video.removeEventListener("stalled", handleStalled);
    };
  }, []);

  return (
    <section id="home">
      <div className="hero-wrap">
        <div className="hero-mask opacity-8 bg-dark" />

        {/* ---------------image background------------------ */}
{/*         <div
          className="hero-bg parallax"
          style={{ backgroundImage: 'url("images/intro-bg.jpg")' }}
        ></div> */}

        {/* -------------------video background---------------------- */}

        {<div className="player hero-bg parallax">
          {!videoError ? (
            <video
              ref={videoRef}
              src={videobg}
              poster={posterImg}
              autoPlay
              muted
              loop
              playsInline={true}
              preload="auto"
              controls={false}
              disablePictureInPicture
              style={{ width: "100%", height: "100vh", objectFit: "cover" }}
            ></video>
          ) : (
            <div
              style={{
                width: "100%",
                height: "100vh",
                backgroundImage: `url(${posterImg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
              }}
            ></div>
          )}
        </div>}

        <div className="hero-content section d-flex min-vh-100">
          <div className="container my-auto">
            <div className="row">
              <div className="col-12 text-center">
                <p className="text-7 fw-500 text-white mb-2 mb-md-3">{homeContent.welcome}</p>
                <h2 className="text-16 fw-600 text-white mb-2 mb-md-3">
                  <Typewriter
                    options={{
                      strings: homeContent.typewriter,
                      autoStart: true,
                      loop: true,
                    }}
                  />
                </h2>
                <p className="text-5 text-light mb-4">
                  {homeContent.location}
                </p>
                <a
                  href="#contact"
                  className="btn btn-outline-primary rounded-pill shadow-none smooth-scroll mt-2"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick("contact");
                  }}
                >
                  {homeContent.ctaText}
                </a>
              </div>
            </div>
          </div>
          <a
            href="#about"
            className="scroll-down-arrow text-white smooth-scroll"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("about");
            }}
          >
            <span className="animated">
              <i className="fa fa-chevron-down" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Home;
